export default __webpack_public_path__ + "static/media/1384.40f85a38.png";